function percentTrue(o) {
	const sum = Object.values(o).reduce((agg, v) => agg + v, 0);
	const totalKeys = Object.keys(o).length
	return sum / totalKeys;
}

export function objectMap(o, f) {
	let isPromise = false;
	const result = Array.isArray(o) ? [] : {};
	for (const [k, v] of Object.entries(o)) {
		result[k] = f(v, k);
		if (typeof result[k].then === 'function') {
			isPromise = true;
		}
	}
	if (isPromise) {
		const jobs = {};
		const subscribers = [];
		const mapResult = {
			jobs,
			progress: 0,
			onprogress: subscriber => {
				if (typeof subscriber === 'function') {
					subscribers.push(subscriber);
				}
			}
		};
		function notifyAll(progress) {
			for (const sub of subscribers) {
				sub(progress);
			}
		}
		mapResult.data = new Promise(async resolve => {
			const promises = [];
			const finalResult = Array.isArray(result) ? [] : {};
			for (const [k, p] of Object.entries(result)) {
				jobs[k] = 0;
				let proxyResolve;;
				promises.push(new Promise(resolve => proxyResolve = resolve));
				if (typeof p.onprogress === 'function') {
					// report progress everu time the child does.
					p.onprogress(childProgress => {
						jobs[k] = childProgress;
						mapResult.progress = percentTrue(jobs);
						notifyAll(mapResult.progress);
					});
					p.data.then(result => {
						jobs[k] = 1;
						finalResult[k] = result;
						proxyResolve(result);
					})
				} else {
					p.then(v => {
						if (typeof v.onprogress === 'function') {
							v.onprogress(childProgress => {
								jobs[k] = childProgress;
								mapResult.progress = percentTrue(jobs);
								notifyAll(mapResult.progress);
							});
							v.data.then(result => {
								jobs[k] = 1;
								finalResult[k] = result;
								proxyResolve(result);
							});
						} else {
							finalResult[k] = v;
							jobs[k] = 1;
							mapResult.progress = percentTrue(jobs);
							notifyAll(mapResult.progress);
							proxyResolve(v)
						}
					});
				}
			}
			await Promise.all(promises);
			resolve(finalResult);
		});
		return mapResult;
	} else {
		return result
	}
}